import { Controller } from "@hotwired/stimulus"

import Inputmask from "inputmask"

// Connects to data-controller="address"
export default class extends Controller {
  static targets = ['cep', 'street', 'neighborhood', 'city']

  connect() {
    Inputmask(this.cepTarget.dataset.mask).mask(this.cepTarget)
  }

  cep_blur() {
    if (this.cepTarget.value.length === 9) {
      $.post("/utils/cep", { cep: this.cepTarget.value }, (data) => {
        if (data) {
          this.streetTarget.value = data.data.street
          this.neighborhoodTarget.value = data.data.neighborhood
          if (data.city) {
            const citySelect = this.cityTarget.tomselect
            citySelect.clearOptions()
            citySelect.addOption({
              id: data.city.id,
              name: data.city.name,
            })
            citySelect.setValue(data.city.id)
            setTimeout(() => {
              this.streetTarget.focus()
            }, 0)
          }
        }
      })
    } else {
      alert('CEP inválido')
    }
  }
}
